import React, { Component } from 'react';
import ReactModal from 'react-modal';

import { CloseIcon } from '../../icons/CloseIcon';
import { colors } from '../../themes/Colors';

import { CloseIconWrapper } from './styledComponents';

import './styles.scss';

interface Props {
  children: React.ReactNode;
  hideCloseIcon?: boolean;
  isModalOpen?: boolean;
  [x: string]: any;
  baseModalContainerStyles?: string;
  onModalClose?: () => void;
  closeIconButtonId?: string;
  closeIconWrapperStyles?: string;
}

interface State {
  modalIsOpen: boolean;
}

ReactModal.defaultStyles.overlay.backgroundColor = colors.black80;

class BaseModalContainer extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modalIsOpen: props.isModalOpen ? props.isModalOpen : false
    };
  }

  static defaultProps = {
    hideCloseIcon: false
  };

  openModal = () => {
    this.setState({
      modalIsOpen: true
    });
  };

  closeModal = () => {
    this.props.onModalClose && this.props.onModalClose();
  };

  UNSAFE_componentWillMount() {
    ReactModal.setAppElement('body');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isModalOpen } = this.props;

    if (nextProps.isModalOpen !== isModalOpen) {
      this.setState({ modalIsOpen: nextProps.isModalOpen });
    }
  }

  onModalOpen = () => {
    document.body.style.overflow = 'hidden';
  };
  onModalClose = () => {
    document.body.removeAttribute('style');
  };

  render() {
    const {
      children,
      hideCloseIcon,
      isModalOpen,
      baseModalContainerStyles,
      crossIcon: CrossIcon,
      closeIconButtonId,
      closeIconWrapperStyles,
      ...other
    } = this.props;
    const { modalIsOpen } = this.state;

    return (
      <ReactModal
        className={`baseModalStyles ${baseModalContainerStyles}`}
        overlayClassName={`baseModalOverlayStyles ${baseModalContainerStyles}-overlay`}
        closeTimeoutMS={0}
        isOpen={modalIsOpen}
        onAfterOpen={this.onModalOpen}
        onAfterClose={this.onModalClose}
        {...other}
      >
        {hideCloseIcon ? null : (
          <CloseIconWrapper
            css={closeIconWrapperStyles}
            id={closeIconButtonId}
            onClick={this.closeModal}
          >
            {CrossIcon ? (
              <CrossIcon />
            ) : (
              <CloseIcon fill={colors.blueGreyTwo} />
            )}
          </CloseIconWrapper>
        )}

        {children}
      </ReactModal>
    );
  }
}

export { BaseModalContainer };
